import {Navigate} from 'react-router-dom';
import Menu from 'UI/Application/Components/Menus/admin/Menu';
import {useAuthContext} from 'Shared/Security/Domain/Contexts/authContext';
import { PRIVATE } from 'Shared/Routing/Application/Constants/PathsConstant';

export default function AdminRoute() {
  const {isAdmin} = useAuthContext();

  if (!isAdmin()) {
    return <Navigate to={PRIVATE} />;
  }

  return (
    <Menu/>
  );
}
